import { ISnoozeTimer } from "./ISnoozeTimer";

export class SnoozeTimer implements ISnoozeTimer {
	timeoutId?: ReturnType<typeof setTimeout>;

	notificationId?: string;

	wakeEpochMilliseconds?: number;

	snoozeInterval?: number;
}
